export default {"src":"/_next/static/media/canada.9c45573b.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};